var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 40,
    viewBox: "0 0 113 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.662 12.212v1.512c-2.088.108-3.366 1.35-3.366 3.222 0 1.728 1.062 2.736 3.366 3.204v5.202c-1.962-.144-2.862-1.116-2.826-3.042h-1.044c-.054 2.376 1.422 3.87 3.87 3.924v2.052h.774v-2.052c.972-.072 1.53-.198 2.034-.504 1.062-.612 1.638-1.656 1.638-2.952 0-1.926-1.116-2.988-3.672-3.474v-4.68c1.548.108 2.34.918 2.376 2.448l1.026.018c.054-1.998-1.242-3.276-3.402-3.366v-1.512h-.774zm0 6.912c-.756-.18-1.08-.306-1.368-.486-.648-.378-.99-1.008-.99-1.764 0-1.35.882-2.196 2.358-2.268v4.518zm.774 1.188c1.008.306 1.242.396 1.548.576.72.414 1.098 1.08 1.098 1.962 0 .756-.288 1.422-.846 1.872-.45.396-.918.558-1.8.63v-5.04z",
    fill: "#929BA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.10d1601722498ebd9bdc8c5b0674b740.svg";
export { ForwardRef as ReactComponent };